export class DeletePermissionViewModel {
    permissionID: number;
    description: string;
    permissionName: string;
    deletedBy: number;
    deletedOn: Date;
}
